import React, { PureComponent } from 'react'
import styled, { keyframes } from 'styled-components'

import withTransition from '../../hoc/Transition'
import withLoading from '../../hoc/Loading'
import { IWinnerPlayerData } from '../../helpers/data/winnerPlayer'
import Label from '../../components/label/Label'

import getPalette, { IPalette } from '../../helpers/colors/colors'
import Asset from '../../components/asset/Asset'
import { IAssetData } from '../../helpers/data/assetData'
import getFont from '../../helpers/fonts/fonts'
import lottieRendererEnums from '../../helpers/enums/lottieRenderer'
import settingsEnums from '../../helpers/enums/settings'
const colors: IPalette = getPalette()

const Wrapper = styled.div`
	width: 100%;
	height: 100%;
	background-size: cover;
	position: relative;
`

const BackgroundContainer = styled.div`
	width: 100%;
	height: 100%;
	margin: auto;
	position: absolute;
	top: 0;
	left: 0;
`

const PlayerContainer = styled.div`
	width: 68%;
	height: 92%;
	margin: auto;
	position: absolute;
	top: 22%;
	left: 10%;
`

const YetiContainer = styled.div`
	width: 34%;
	height: 46%;
	margin: auto;
	position: absolute;
	top: 36%;
	left: 52%;
`

const LabelContainer = styled.div`
	font-size: 26%;
	position: absolute;
	top: 47%;
	left: 33%;
`

const BottomTitle = styled.div`
	width: 100%;
	font-size: 45%;
	font-family: ${getFont('secondaryRegular')};
	text-align: center;
	position: absolute;
	left: 0;
`

const progressBarIn = keyframes`
  0% {
    transform: scale(0, 1);
    animation-timing-function: ease-out;
  }
  100% {
    transform: scale(1, 1);
  }
`

const QuestionProgressBar = styled.div`
	width: 100%;
	height: 3%;
	animation: ${progressBarIn} 5s;
	transform-origin: 0 0;
	position: absolute;
	bottom: 0;
	left: 0;
`

const ScreenReaderOnly = styled.div`
	position: absolute;
	width: 1px;
	height: 1px;
	padding: 0;
	margin: -1px;
	overflow: hidden;
	clip: rect(0, 0, 0, 0);
	white-space: nowrap;
	border: 0;
`

interface IMessageData {
	position: string
	color: string
}

export interface ISkin {
	background: IAssetData
	animation: IAssetData
	message: IMessageData
	progressBar: IProgressBarData
}

interface IProgressBarData {
	color: string
}

interface IPlantFlagProps {
	player: IWinnerPlayerData
	onViewLoaded: () => void
	skin: ISkin
	isTimerDisabled: number
}

interface IPlantFlagState {
	announcement: string
}

const defaultMessageStyle = {
	position: 'top',
	color: colors.primary,
}

class PlantFlag extends PureComponent<IPlantFlagProps, IPlantFlagState> {

	state = {
		announcement: '',
	}

	componentDidMount() {
		this.setState({
			announcement: `${this.props.player.nickname} wins with ${this.props.player.score} points`,
		})
	}

	buildMessageStyle(messageStyle: IMessageData): React.CSSProperties {
		if (!messageStyle) {
			messageStyle = defaultMessageStyle
		}

		const position = messageStyle.position || 'top'

		return {
			color: messageStyle.color || colors.primary,
			top: position === 'top' ? '5%' : 'unset',
			bottom: position === 'bottom' ? '5%' : 'unset',
		}
	}

	render() {
		const progressBarBackgroundColor = this.props.skin.progressBar
			? this.props.skin.progressBar.color
			: 'rgb(0, 87, 133)'
		return (
			<Wrapper>
				{this.state.announcement && <ScreenReaderOnly role="alert" >
					{this.state.announcement}
				</ScreenReaderOnly>}
				<BackgroundContainer>
					<Asset onLoad={this.props.onViewLoaded} asset={this.props.skin.background} />
				</BackgroundContainer>
				<YetiContainer>
					<Asset asset={this.props.skin.animation} />
				</YetiContainer>
				<PlayerContainer>
					<Asset
						asset={this.props.player.flagAsset}
						uid={this.props.player.playerUID + this.props.player.avatarId}
						renderer={lottieRendererEnums.CANVAS}
					/>
				</PlayerContainer>
				<LabelContainer aria-hidden="true">
					<Label text={this.props.player.nickname} />
				</LabelContainer>
				<BottomTitle style={this.buildMessageStyle(this.props.skin.message)}>Nice Work!</BottomTitle>
				{this.props.isTimerDisabled === settingsEnums.SETTING_TIMER_DEFAULT && <QuestionProgressBar
					style={{
						backgroundColor: progressBarBackgroundColor,
					}}
				/>}
			</Wrapper>
		)
	}
}

export default withTransition(withLoading(PlantFlag))
